import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

type UsageAndCostTooltipWrapperProps = PropsWithChildren & {
    label: string
    tooltipItemsWrapperClassname?: string
    dataCompleteness?: {
        usnsWithData: number
        totalUsns: number
    }
    hasVarianceBadge?: boolean
}

export const UsageAndCostTooltipWrapper: React.FC<
    UsageAndCostTooltipWrapperProps
> = (props) => {
    const {
        label,
        children,
        tooltipItemsWrapperClassname,
        dataCompleteness,
        hasVarianceBadge = false,
    } = props
    const { t } = useTranslation('translations')
    const defaultWrapperClassname = hasVarianceBadge
        ? 'grid grid-cols-[auto_auto_auto_auto] items-center overflow-hidden gap-x-2 gap-y-1 z-[50]'
        : 'grid grid-cols-[auto_auto_auto] items-center overflow-hidden gap-x-2 gap-y-1 z-[50]'
    const wrapperClassname =
        tooltipItemsWrapperClassname ?? defaultWrapperClassname

    const percentageValue =
        dataCompleteness && dataCompleteness.totalUsns > 0
            ? (dataCompleteness.usnsWithData / dataCompleteness.totalUsns) * 100
            : 0
    const percentageDisplay = percentageValue.toFixed(1)

    return (
        <div className="relative rounded-lg border border-neutral-200 bg-white px-3 py-2 shadow-sm">
            <div className="space-y-2">
                <div className="text-heading-7">{label}</div>
                <div className={wrapperClassname}>
                    {children}
                    {dataCompleteness && (
                        <>
                            <div
                                className="border-t border-neutral-200"
                                style={{ gridColumn: '1 / -1' }}
                            />
                            <span className="text-label-xsmall text-subtle">
                                {t(
                                    'analytics.usage_and_cost.chart_tooltip.data_completeness'
                                )}
                            </span>
                            <span className="text-label-xsmall justify-self-end font-bold text-subtle">
                                {dataCompleteness.usnsWithData} /{' '}
                                {dataCompleteness.totalUsns}
                            </span>
                            <span className="text-label-xsmall inline-flex min-w-6 items-center justify-center gap-0.5 justify-self-end rounded-[6px] border border-neutral-300 px-1 py-[2px] text-regular">
                                {percentageDisplay}%
                            </span>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
